import { IAddress } from '@bciti/types';
import { Observable } from 'rxjs';
import { SearchAddressPayload } from 'src/app/interfaces/address/address.interface';

export abstract class AddressService {
    abstract getAddressParams(address: SearchAddressPayload): Observable<IAddress[]>;
    abstract getAddressQuery(query: string): Observable<IAddress[]>;
}
